import { createAsyncThunk } from '@reduxjs/toolkit';
import doFetch from 'utils/api/doFetch';

import type {
  ReapplyProtectedConfigApiRequestBody,
  ReapplyProtectedConfigApiResponseType,
} from 'redux-store/slices/groupConfigDevices/types';

const reapplyProtectedConfigurationThunk = createAsyncThunk(
  'organizations/reapplyProtectedConfigurationThunk',
  async ({
    technicianPassword,
    deviceId,
  }: {
    technicianPassword: ReapplyProtectedConfigApiRequestBody;
    deviceId: number;
  }): Promise<ReapplyProtectedConfigApiResponseType> => {
    try {
      const apiPointName = 'reapplyProtectedConfiguration';

      return await doFetch<typeof apiPointName>({
        apiPointName,
        body: technicianPassword,
        urlParams: { id: deviceId },
      });
    } catch (e) {
      return Promise.reject(e);
    }
  },
);

export default reapplyProtectedConfigurationThunk;
